module.exports = __webpack_public_path__ + "media/images/flags/lt-76a1bf55ea5892481b9327ef1d026a2d.svg";